import { Link as WalrusLink } from '@do/walrus';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars.scss';

const Link = styled(WalrusLink)`
  color: ${vars.primary};
  font-family: 'JetBrains Mono', monospace;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`;

export default Link;
